export default "__VITE_ASSET__e62c8d4b__"